var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"Component",staticClass:"c-scoped-color-theme",class:( _obj = {}, _obj[("c-scoped-color-theme--" + _vm.mappedTheme)] = _vm.mappedTheme, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }